import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';

// Importaciones de componentes.
import { LogDeleteAllDialogComponent } from './log-delete-all-dialog.component';

@NgModule({
  declarations: [LogDeleteAllDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  exports: [LogDeleteAllDialogComponent],
})
export class LogDeleteAllDialogModule {}
